module.exports = __webpack_public_path__ + "media/images/lb/627-223d7db04086170f05682be5d4883ca0.svg";